import {hyrbrids} from "./AsxHybrids";
import {Exchange} from "../../../instruments/exchange/Exchange";

export class AsxHybridsUtil {
    public static isHybrid(code: string): boolean {
        return hyrbrids.find((security) => security.code === code) != null;
    }

    public static exchange(code: string): Exchange {
        const hybrid = hyrbrids.find((security) => security.code === code);
        if (hybrid == null) {
            return Exchange.ASX;   // Dodgy as hell, but must return something. Brock is going to kill me.
        }
        return hybrid.exchange;
    }
}